import BANKS from '@sdk/helpers/domains/banks';

export function find(bank) {
  if (!bank) {
    return {};
  }

  return Object.values(BANKS).find(b => b.code === bank.febraban_code);
}

export function kind(attempt) {
  if (!attempt.bank) {
    return null;
  }

  const bank = find(attempt.bank);

  if (bank) {
    return bank.destination;
  }

  return null;
}

export default function url(attempt) {
  if (!attempt.bank) {
    return null;
  }

  const bank = find(attempt.bank);

  if (bank && attempt.bank_proposal_identifier) {
    if (/:identifier/.test(bank.url)) {
      return bank.url.replace(/:identifier/, attempt.bank_proposal_identifier);
    }

    return bank.url;
  }

  return null;
}
